<template>
  <div class="flex pt12 pl16 pr16 product-list van-hairline--bottom" style="padding-bottom: 8px">
    <div class="img-content" @click="pageDetail(item.itemId, item.isDrug)">
      <van-image
        width="74"
        height="74"
        :src="item.mainImg + '?x-oss-process=image/resize,m_fill,h_97,w_97'"
        :ref="'fly-img' + item.itemId"
        class="custom-image"
      >
        <!-- <slot><span v-if="isDrugItem && item.isRx === RxTypeNum.CHUFANGYA0" class="prescription"></span></slot> -->
        <slot><span v-if="isDrugItem && item.isRx === RxTypeNum.OTC" class="otc"></span></slot>

        <template v-slot:error>
          <img width="90%" height="90%" fit="contain" :src="require('@/assets/imgs/home/shop.png')" />
        </template>

        <template v-slot:loading>
          <img width="90%" height="90%" fit="contain" :src="require('@/assets/imgs/home/shop.png')" />
        </template>
      </van-image>
      <FlyProduct
        :targetId="targetId"
        :dropImage="item.mainImg"
        :ref="'fly-product' + item.itemId"
        class="drop-image"
      />
      <span
        class="rx-shade"
        v-if="isDrugItem && item.isRx === RxTypeNum.CHUFANGYA0 && rxShadeConfig['shop-compliance-open']"
        :style="rxShadeStyle"
      >
        {{ rxShadeConfig['shop-compliance-content']['tips'] }}
      </span>
    </div>
    <div class="right">
      <div class="name van-multi-ellipsis--l2" @click="pageDetail(item.itemId, item.isDrug)">
        {{ item.name || item.itemName }}
        {{ item.specifications }}
      </div>
      <div class="company ellipsis" style="margin-top: 4px; width: 169px" @click="pageDetail(item.itemId, item.isDrug)">
        {{ item.manufacturer }}
      </div>
      <div class="coupon" style="height: 12px; margin-top: 8px">
        <img
          v-if="hasCoupon || item.hasCoupon"
          width="17px"
          height="12px"
          fit="contain"
          :src="require('@/assets/imgs/coupon/category-coupon.png')"
        />
      </div>
      <div class="flex space-between bom" style="align-items: center">
        <div
          class="price"
          @click="pageDetail(item.itemId, item.isDrug)"
          v-track-event.click="{ trackId: 'zyyd-click-CartGoods', custom: { itemId: item.itemId } }"
        >
          <span>{{ item.realPrice | price }}</span>
        </div>
        <div class="action" v-if="item.drugTypeClassification != 1">
          <van-stepper
            :ref="'stepper' + item.itemId"
            :value="item.goodsNumAdded || ''"
            theme="round"
            integer
            allow-empty
            @plus="plus(item)"
            @minus="minus(item)"
            @blur="handleBlur"
            @overlimit="overlimit(item)"
            @change="handChange"
            async-change
            :show-minus="item.goodsNumAdded > 0"
            :show-plus="item.stock !== 0"
            :min="0"
            :max="item.stock < 999 ? item.stock : 999"
            button-size="22"
            :disable-input="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FlyProduct from '@/pages/home/components/flyProduct.vue';
import { RxTypeNum } from '@/constant';
import { mapState } from 'vuex';

export default {
  props: {
    item: {
      type: Object,
      default: () => ({
        goodsNumAdded: null
      })
    },
    hasCoupon: {
      type: Boolean,
      default: false
    },
    targetId: {
      type: String,
      default: 'fly-cart-target'
    },
    isCustomToDetail: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FlyProduct
  },
  data() {
    return {
      isTip: false, // 是否提示用户
      RxTypeNum
    };
  },
  computed: {
    ...mapState(['rxShadeConfig']),
    rxShadeStyle() {
      const content = this.rxShadeConfig['shop-compliance-content'];
      return {
        color: `#${content.textColor}`,
        background: `#${content.bgColor}`,
        opacity: content.alpha,
        fontSize: `${content.textSize}px`
      };
    },
    isDrugItem() {
      return this.item.isDrug === 1;
    }
  },
  methods: {
    // 删除购物车
    deleteTrolley() {
      const { itemId, isDrug } = this.item;
      console.log(this.item.goodsNumAdded);
      this.$dialog
        .confirm({
          title: '确认删除药品？',
          confirmButtonText: '再想想',
          cancelButtonText: '删除'
        })
        .then(() => {
          this.$refs['stepper' + itemId].currentValue = this.item.goodsNumAdded;
        })
        .catch(() => {
          this.$fetch.deleteTrolley({ itemId, isDrug }).then(() => {
            this.item.goodsNumAdded = 0;
            this.$emit('changeGoodsAmount');
          });
        });
    },
    addTrolley(goodsNumAdded, status) {
      if (goodsNumAdded === this.item.goodsNumAdded) return;
      const { itemId, isDrug } = this.item;
      this.$fetch
        .addTrolley({ itemId, amount: goodsNumAdded, isDrug })
        .then(({ amount, stockNum, canAdd, message = '' }) => {
          this.$nextTick(() => {
            this.$set(this.item, 'goodsNumAdded', amount);
          });
          if (!canAdd) {
            this.item.stockNum = stockNum;
            this.item.goodsNumAdded = amount;
            this.$toast(message);
            this.$refs['stepper' + this.item.itemId].currentValue = amount;
            return;
          }
          if (this.isTip) {
            this.overlimit();
          }
          if (status === 'add') {
            window.localStorage.setItem('recentAddType', isDrug);

            this.$refs['fly-product' + itemId].addToCart(this.$refs['fly-img' + itemId]);
          }
          if (goodsNumAdded === 1 && status === 'add') {
            this.$emit('changeGoodsAmount');
          }
          // this.item.goodsNumAdded = amount;
          // this.$refs['stepper' + itemId].currentValue = amount;
        });
      console.log(this.item);
    },
    minus() {
      const goodsNumAdded = Number(this.$refs['stepper' + this.item.itemId].currentValue) - 1;
      if (goodsNumAdded < 1) {
        this.deleteTrolley();
        return;
      }
      this.addTrolley(goodsNumAdded);
    },
    plus() {
      const goodsNumAdded = Number(this.$refs['stepper' + this.item.itemId].currentValue) + 1;
      // console.log(goodsNumAdded);
      // console.log(this.$refs['stepper' + this.item.itemId]);
      this.addTrolley(goodsNumAdded, 'add');
    },
    handleBlur() {
      const goodsNumAdded = Number(this.$refs['stepper' + this.item.itemId].currentValue);

      if (goodsNumAdded === 0) {
        this.$refs['stepper' + this.item.itemId].currentValue = 1;
        return this.addTrolley(1, true);
      }
      this.addTrolley(goodsNumAdded);
    },
    overlimit() {
      if (this.item.stock < 999) {
        this.$toast(`您最多可购买${this.item.stock}件`);
      } else {
        this.$toast('您最多可购买999件');
      }
    },
    handChange(v) {
      if (v === 999 || v === this.item.stock) return;
      this.isTip = !!(Number(v) > this.item.stock);
    },
    pageDetail(itemId, isDrug) {
      if (this.isCustomToDetail) {
        this.$emit('onPageToDetail', { itemId, isDrug });
      } else {
        this.$router.push({ path: `/specification?itemId=${itemId}&isDrug=${isDrug}` });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.product-list {
  width: 100%;
  position: relative;

  .drop-image {
    position: absolute;
    top: 0;
    left: 0;
  }
}
.show-bottom-border {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.img-content {
  position: relative;
  .custom-image {
    overflow: hidden;
    border-radius: 4px;
    background: #fafafa;
  }
  .prescription {
    background: url('../assets/imgs/tag_chufang.png') no-repeat top left/100% 100%;
    width: 32px;
    height: 14px;
    display: inline-block;
    position: absolute;
    top: 4px;
    left: 4px;
  }
  .otc {
    background: url('../assets/imgs/tag_otc.png') no-repeat top left/100% 100%;
    width: 32px;
    height: 14px;
    display: inline-block;
    position: absolute;
    top: 4px;
    left: 4px;
  }
  .mask {
    position: absolute;
    display: inline-block;
    width: 72px;
    height: 72px;
    left: 0;
    top: 0;
    background: rgba(51, 51, 51, 0.8);
    z-index: 1;
    border-radius: 4px;
    opacity: 0.5;
  }
  .no-stock {
    position: absolute;
    display: inline-block;
    width: 50px;
    height: 50px;
    z-index: 2;
    background: #333333;
    box-shadow: 0px 1px 4px 0px rgba(51, 51, 51, 0.5);
    opacity: 0.8;
    top: 11px;
    left: 11px;
    border-radius: 50px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 50px;
  }
  .rx-shade {
    position: absolute;
    top: 0;
    left: 0;
    width: 74px;
    height: 74px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.right {
  margin-left: 8px;
  width: calc(100% - 78px);
  // padding-bottom: 12px;
  display: flex;
  flex-direction: column;
  .name {
    font-size: 14px;
    line-height: 21px;
    // min-height: 42px;
    color: #262626;
    font-weight: 500;
    max-height: 42px;
  }
  .bom {
    // font-weight: 500;
    // position: absolute;
    // bottom: 12px;
    // width: 169px;;
  }
  .company,
  .size {
    height: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8c8c8c;
    line-height: 12px;
    // max-width: 50%;
  }
  .price {
    width: 81px;
    height: 16px;
    flex: 1;
    font-size: 16px;
    font-weight: 500;
    color: #ff4e47;
    line-height: 16px;
    &::before {
      content: '￥';
      font-size: 12px;
    }
  }

  .sub_button {
    width: 88px;
    height: 24px;
    padding: 0;
    font-size: 12px !important;
    border-radius: 4px;
  }
  ::v-deep.van-stepper {
    .van-stepper__minus {
      color: #118dff;
      background-color: #fff;
      border: 1px solid #118dff;
    }
    .van-stepper__plus {
      color: #fff;
      background-color: #1e8dff;
    }
    .van-stepper__minus::before,
    .van-stepper__plus::before {
      height: 2px;
    }
    .van-stepper__minus::after,
    .van-stepper__plus::after {
      width: 2px;
    }
    button {
      width: 24px !important;
      height: 24px !important;
    }
  }
}
</style>
